/**
 * Resolves an emitter's raw `SubResource("id")` and `ExtResource("id")` strings against
 * `SceneResources` at render time: the parser sees a node's body, not the scene's resource table.
 * An ExtResource resolves once its file has loaded. Pure `.ts`, with only the shared decoders and no
 * THREE of its own.
 */
import { decodeCurveResource } from '../../../resources/curves/curve/decode';
import { referencedFilePath, resolveReferencedResource } from '../../../resources/resolveReference';
import { CPU_PARTICLES_PARAM_COUNT } from './params';
/** The `curve` reference of each parameter slot, always `CPU_PARTICLES_PARAM_COUNT` long. */
export function paramCurveReferences(params) {
    return Array.from({ length: CPU_PARTICLES_PARAM_COUNT }, (_, slot) => params[slot]?.curve);
}
/** The `.tres` files the emitter's curve and ramp `references` load from. */
export function particleFiles(references, pools) {
    return references.flatMap((ref) => referencedFilePath(ref, pools) ?? []);
}
/** The `Curve` a reference names, or null for none, a missing one and another type. */
export function resolveParticleCurve(ref, pools, loadedFile) {
    return decodeCurveResource(resolveReferencedResource(ref, pools, loadedFile));
}
/**
 * One decoded `Curve` per parameter slot, `null` where the slot names none.
 * Always `CPU_PARTICLES_PARAM_COUNT` long, so the simulation can index it
 * by `CPUParticlesParameter` without a bounds check.
 */
export function resolveParticleCurves(params, pools, loadedFile) {
    return paramCurveReferences(params).map((ref) => resolveParticleCurve(ref, pools, loadedFile));
}
//# sourceMappingURL=sceneResources.js.map